import { render, staticRenderFns } from "./PriceManipulationHandler.vue?vue&type=template&id=53f97c86&scoped=true"
import script from "./PriceManipulationHandler.vue?vue&type=script&lang=ts"
export * from "./PriceManipulationHandler.vue?vue&type=script&lang=ts"
import style0 from "./PriceManipulationHandler.vue?vue&type=style&index=0&id=53f97c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f97c86",
  null
  
)

export default component.exports